/* Letters from the studio: a letter's reading progress, side rail and sign-off (sections/cozyleigh-article.liquid).
   - Progress: the tape along the top fills from the start to the end of the letter's body.
   - Rail: article love is account-linked through the Shopify App Proxy, with its public aggregate count;
     "Share" opens the phone's share sheet, or copies the link; "Next letter" jumps to the page's newsletter section
     (hidden when there isn't one). Below 1200px the rail is a small bar that shows once you're past the title and
     tucks away again at the replies and the footer.
   - Sign-off: the last "From our family, to yours" paragraph in the letter gets the terracotta sign-off style.
   Re-runs on shopify:section:load so the theme editor keeps working. */
(function () {
  function init(root) {
    var art = root.querySelector('[data-clar]');
    if (!art || art.getAttribute('data-clar-ready')) return;
    art.setAttribute('data-clar-ready', '1');
    var body = art.querySelector('.clar__body');
    var rail = art.querySelector('[data-clar-rail]');
    // the progress tape moves up to <body> so it sits above the sticky header (sections stack below it)
    var prog = document.querySelectorAll('[data-clar-progress]');
    for (var j = 0; j < prog.length - 1; j++) prog[j].remove();
    if (prog.length && prog[prog.length - 1].parentNode !== document.body) document.body.appendChild(prog[prog.length - 1]);
    var bar = document.querySelector('[data-clar-progress] span');

    // sign-off
    if (body) {
      var ps = [].slice.call(body.querySelectorAll('p')).reverse();
      for (var i = 0; i < ps.length && i < 6; i++) {
        if (/from our family,?\s+to yours/i.test(ps[i].textContent) && ps[i].textContent.length < 60) { ps[i].classList.add('clar__signoff'); break; }
      }
    }

    // progress + bar visibility
    var talk = art.querySelector('.clar__talk') || art.querySelector('.clar__nav');
    var head = art.querySelector('.clar__head');
    var footer = document.querySelector('.section-footer, footer');
    var ticking = false;
    function onScroll() {
      ticking = false;
      var vh = window.innerHeight;
      if (bar && body) {
        var r = body.getBoundingClientRect();
        var p = (vh * 0.35 - r.top) / Math.max(r.height, 1);
        bar.parentNode.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(4));
      }
      if (!readComplete && body) {
        var bodyRect = body.getBoundingClientRect();
        var bodyTop = bodyRect.top + window.scrollY;
        if (window.scrollY > 0 && window.scrollY > bodyTop && bodyRect.bottom <= vh) {
          readComplete = true;
          if (window.clAnalytics && typeof window.clAnalytics.blogEngagement === 'function') {
            window.clAnalytics.blogEngagement('read_complete', art.getAttribute('data-clar-handle'));
          }
        }
      }
      if (rail) {
        var past = head ? head.getBoundingClientRect().bottom < 0 : true;
        var atTalk = talk ? talk.getBoundingClientRect().top < vh * 0.85 : false;
        var atFoot = footer ? footer.getBoundingClientRect().top < vh : false;
        rail.classList.toggle('is-shown', past && !atTalk && !atFoot);
      }
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }
    var readComplete = false;
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    onScroll();

    if (!rail) return;

    var articleHandle = art.getAttribute('data-clar-handle');
    var reportBlogAction = function (action) {
      if (window.clAnalytics && typeof window.clAnalytics.blogEngagement === 'function') {
        window.clAnalytics.blogEngagement(action, articleHandle);
      }
    };

    // account-linked article likes
    var love = rail.querySelector('[data-clar-love]');
    if (love) {
      var endpoint = love.getAttribute('data-clar-like-endpoint');
      var articleId = love.getAttribute('data-clar-love');
      var countBadge = love.querySelector('[data-clar-like-count]');
      var countLabel = love.querySelector('[data-clar-like-count-label]');
      var likeStatus = love.querySelector('[data-clar-like-status]');
      var lab = love.querySelector('.clar__lab');
      var authenticated = love.tagName.toLowerCase() === 'button';
      var known = false;
      var liked = false;
      var busy = false;

      function setBusy(value) {
        busy = value;
        if (authenticated) love.disabled = value;
      }
      function setStatus(message) {
        if (likeStatus) likeStatus.textContent = message;
      }
      function setLikeState(state) {
        liked = state.liked;
        known = true;
        if (authenticated) {
          love.setAttribute('aria-pressed', liked ? 'true' : 'false');
          if (lab && lab.firstChild) lab.firstChild.nodeValue = liked ? lab.getAttribute('data-on') : lab.getAttribute('data-off');
        }
        if (countBadge) {
          countBadge.textContent = state.count > 0 ? String(state.count) : '';
          countBadge.hidden = state.count === 0;
        }
        if (countLabel) countLabel.textContent = state.count === 1 ? ' 1 like' : ' ' + state.count + ' likes';
      }
      function readLikeState() {
        if (!endpoint || !/^\d+$/.test(articleId || '')) return Promise.reject(new Error('Invalid article like endpoint.'));
        var url;
        try { url = new URL(endpoint, window.location.origin); } catch (error) { return Promise.reject(error); }
        if (url.origin !== window.location.origin || url.pathname !== '/apps/engagement/articles/' + articleId + '/like') {
          return Promise.reject(new Error('Invalid article like endpoint.'));
        }
        return window.fetch(url.href, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }).then(function (response) {
          if (!response.ok) throw new Error('Article likes could not be loaded.');
          return response.json();
        }).then(function (data) {
          if (!data || typeof data.liked !== 'boolean' || !Number.isSafeInteger(data.count) || data.count < 0) {
            throw new Error('Article likes response was invalid.');
          }
          return data;
        });
      }
      function loadLikeState() {
        setBusy(true);
        setStatus('Loading article likes.');
        readLikeState().then(function (state) {
          setLikeState(state);
          setStatus('');
        }).catch(function () {
          setStatus('Likes are unavailable. Tap to try again.');
        }).then(function () {
          setBusy(false);
        });
      }
      function updateLikeState(desired) {
        setBusy(true);
        setStatus('Updating your love.');
        window.fetch(new URL(endpoint, window.location.origin).href, {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ liked: desired })
        }).then(function (response) {
          if (!response.ok) {
            var error = new Error(response.status === 401 ? 'Please sign in again to love this article.' : 'Your love could not be updated. Please try again.');
            error.status = response.status;
            throw error;
          }
          return response.json();
        }).then(function (data) {
          if (!data || typeof data.liked !== 'boolean' || !Number.isSafeInteger(data.count) || data.count < 0) {
            throw new Error('Your love could not be updated. Please try again.');
          }
          var changed = data.liked !== liked;
          setLikeState(data);
          setStatus('');
          love.classList.remove('is-popped');
          void love.offsetWidth;
          if (data.liked) love.classList.add('is-popped');
          if (changed) reportBlogAction(data.liked ? 'like' : 'unlike');
        }).catch(function (error) {
          setStatus(error && error.status === 401 ? error.message : 'Your love could not be updated. Please try again.');
        }).then(function () {
          setBusy(false);
        });
      }

      if (authenticated) {
        love.addEventListener('click', function (event) {
          if (busy) {
            event.preventDefault();
            return;
          }
          if (!known) {
            event.preventDefault();
            loadLikeState();
            return;
          }
          updateLikeState(!liked);
        });
      }
      loadLikeState();
    }

    // share
    var share = rail.querySelector('[data-clar-share]');
    if (share) {
      var slab = share.querySelector('.clar__lab');
      var said = slab ? slab.textContent : '';
      share.addEventListener('click', function () {
        var url = share.getAttribute('data-url') || location.origin + location.pathname;
        var title = share.getAttribute('data-title') || document.title;
        reportBlogAction('share_click');
        var done = function () {
          reportBlogAction('share_clipboard_copied');
          if (slab) { slab.textContent = 'Link copied'; setTimeout(function () { slab.textContent = said; }, 2200); }
        };
        var mailto = function () {
          reportBlogAction('share_mailto_handoff');
          location.href = 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url);
        };
        if (navigator.share) {
          try {
            var shareResult = navigator.share({ title: title, url: url });
            if (shareResult && typeof shareResult.then === 'function') {
              shareResult.then(function () {
                reportBlogAction('share_web_success');
              }, function () {});
              return;
            }
          } catch (error) {}
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try { navigator.clipboard.writeText(url).then(done, mailto); } catch (error) { mailto(); }
        } else mailto();
      });
    }

    // Record only that a valid native Shopify comment form was submitted, never its contents.
    var commentForm = art.querySelector('.clar__talk .clar__form');
    if (commentForm) commentForm.addEventListener('submit', function () {
      reportBlogAction('comment_submit_intent');
    });

    // next letter: the page's newsletter section
    var follow = rail.querySelector('[data-clar-follow]');
    if (follow) {
      var news = document.querySelector('.shopify-section[id*="newsletter"]');
      if (news && news.id) { follow.setAttribute('href', '#' + news.id); follow.hidden = false; }
    }
  }

  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
